import { Trans, useTranslation } from "next-i18next";
import { Box, Flex, Image, useColorModeValue, Center } from "@chakra-ui/react";
import { Container } from "@looksrare/uikit";
import { Button, Text } from "uikit";

const Hero = () => {
  const { t } = useTranslation();
  return (
    <Box
      style={{
        backgroundImage: `url('/images/affiliate-landing-page/${useColorModeValue("light-bg.png", "dark-bg.png")}')`,
        backgroundRepeat: "no-repeat",
        backgroundSize: "cover",
        backgroundPosition: "center",
      }}
    >
      <Container maxWidth="1200px" pt={12}>
        <Flex flexDirection={{ base: "column", md: "row" }}>
          <Center>
            <Box mb={8} position="relative">
              <Trans i18nKey="turnYourInfluenceIntoEth">
                <Box mb={8}>
                  <Text as="span" textStyle="display-01" bold>
                    Turn Your Influence Into{" "}
                  </Text>
                  <Text
                    as="span"
                    textStyle="display-01"
                    bold
                    style={{
                      position: "relative",
                    }}
                    _after={{
                      content: "url('/images/affiliate-landing-page/eth-underline.png')",
                      position: "absolute",
                      bottom: { base: "-25px", md: "-20px" },
                      left: { base: "-25px", md: "-5px" },
                      transform: { base: "scale(0.7)", md: "scale(0.9)" },
                    }}
                  >
                    ETH
                  </Text>
                </Box>
              </Trans>
              <Text textStyle="heading-03" bold mb={8}>
                {t("With the LooksRare Affiliate Program")}
              </Text>
              <Text mb={8}>
                {t("Calling the platforms, people and pioneers at the forefront of the NFT and crypto industry.")}
              </Text>
              <Text mb={8}>
                {t(
                  "With LooksRare’s Affiliate Program, you can keep doing what you do best — while earning ETH rewards every time you send a user to LooksRare."
                )}
              </Text>
              <Button
                as="a"
                href="https://docs.google.com/forms/d/1Fwz3zvxTZf4a3ZGbLrSX7xJdZIAMnPAHm5MSawHhUbk"
                marginLeft="auto"
                target="_blank"
                rel="noopener noreferrer"
              >
                {t("Become an Affiliate")}
              </Button>
            </Box>
          </Center>
          <Center>
            <Box>
              <Image
                ml="auto"
                src="/images/affiliate-landing-page/mobile-with-coins.png"
                alt="Affiliate dashboard on mobile device with ETH coins flying out"
              />
            </Box>
          </Center>
        </Flex>
      </Container>
    </Box>
  );
};

export default Hero;
